module.exports = __webpack_public_path__ + "img/manage-merchant.001ec71b.svg";